import styles from "./styles/NewGenerationLoading.module.css";
import React from "react";

function NewGenerationLoading() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.geo1} />
            <div className={styles.geo2} />
            <div className={styles.geo3} />
            <div className={styles.geo4} />
            <div className={styles.geo5} />
            <div className={styles.content}>
                <svg
                    className={styles.spinner}
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient
                            id="hexGrad"
                            x1="0"
                            y1="0"
                            x2="40"
                            y2="40"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset="0%" stopColor="#00998E" />
                            <stop offset="60%" stopColor="#3FC5EA" />
                            <stop offset="100%" stopColor="#C9E5E2" />
                        </linearGradient>
                    </defs>
                    <polygon
                        points="20,3 34.7,11.5 34.7,28.5 20,37 5.3,28.5 5.3,11.5"
                        stroke="url(#hexGrad)"
                        strokeWidth="2.5"
                        strokeLinejoin="round"
                    />
                </svg>
                <p className={styles.label}>Generating</p>
            </div>
        </div>
    );
}

export default NewGenerationLoading;
